export const FLOAT_WIDGET_SET_PLAYER_OPEN = 'FLOAT_WIDGET_SET_PLAYER_OPEN';
export const FLOAT_WIDGET_SET_FLOAT_MODE = 'FLOAT_WIDGET_SET_FLOAT_MODE';
export const FLOAT_WIDGET_SET_PAGE_LOADED = 'FLOAT_WIDGET_SET_PAGE_LOADED';
export const FLOAT_WIDGET_SET_INIT_PAGE_MODE =
	'FLOAT_WIDGET_SET_INIT_PAGE_MODE';
export const FLOAT_WIDGET_SET_COORDINATES = 'FLOAT_WIDGET_SET_COORDINATES';
export const FLOAT_WIDGET_PLAY_LIVE_EVENT = 'FLOAT_WIDGET_PLAY_LIVE_EVENT';
